import { render, staticRenderFns } from "./Server-Statistics.vue?vue&type=template&id=7bae674e&"
import script from "./Server-Statistics.vue?vue&type=script&lang=js&"
export * from "./Server-Statistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports